import React from "react";
import { Col, Row, Form, Button, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

function FooterOrderNow() {
  const openInNewTab = (url) => {
    // 👇️ setting target to _blank with window.open
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const location = useLocation(); 
  
  return (
    <>
    
    </>
  );
}
export default FooterOrderNow;
